import { defineMessages } from "react-intl";

export default defineMessages({
  chooseYourSubscriptionPaymentPlan: {
    id: "subscriptions.chooseYourSubscriptionPaymentPlan",
    defaultMessage:
      "Choose your <inline>Ring Twice<plus></plus></inline> payment plan",
  },
  youCanCancelTheRenewalOfYourSubscriptionAtAnyMoment: {
    id: "subscriptions.youCanCancelTheRenewalOfYourSubscriptionAtAnyMoment",
    defaultMessage:
      "You can <bold>cancel</bold> the renewal of your subscription at any moment.",
  },
  goBack: {
    id: "globals.goBack",
    defaultMessage: "Go back",
  },
});
